import { createAction, props } from '@ngrx/store';
import { RiskTabData } from '../../../camms-risk/features/risk-register/models/risk-tab-data';

export const setRiskRegisterTabSequence = createAction(
    '[Risk Register] Set Tab Sequence',
    props<{ tabSequence: RiskTabData[] }>(),
);

export const resetRiskRegisterTabSequence = createAction(
    '[Risk Register] Reset Tab Sequence',
);
